import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgHome = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	...props,
	children: [
		/* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("style", { children: ".a,.b{fill:none;}.b{stroke:#fff;stroke-linecap:round;stroke-linejoin:round;stroke-width:1.5px;}" }) }),
		/* @__PURE__ */ _jsx("path", {
			className: "a",
			d: "M0,0H24V24H0Z"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "b",
			d: "M4,8.6V21H20V8.6"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "b",
			d: "M-32-344l10-7,10,7",
			transform: "translate(34 354)"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "b",
			d: "M15,21V15a2,2,0,0,0-2-2H11a2,2,0,0,0-2,2v6"
		})
	]
});
export default SvgHome;
